module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": "",
      "lg6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": "500px"
    }
  }, [_c('v-select-radio', {
    attrs: {
      "label": "wwwwwww",
      "items": _vm.items
    },
    model: {
      value: (_vm.checkboxValue),
      callback: function($$v) {
        _vm.checkboxValue = $$v
      },
      expression: "checkboxValue"
    }
  }), _vm._v(" "), _c('v-select-check', {
    attrs: {
      "items": _vm.items
    },
    model: {
      value: (_vm.checkboxValue),
      callback: function($$v) {
        _vm.checkboxValue = $$v
      },
      expression: "checkboxValue"
    }
  }), _vm._v(" "), _c('v-textarea'), _vm._v(" "), _c('v-html-field', {
    ref: "editor1",
    attrs: {
      "macro": "",
      "label": "html редактор1"
    },
    on: {
      "check": _vm.check
    },
    model: {
      value: (_vm.htmlValue),
      callback: function($$v) {
        _vm.htmlValue = $$v
      },
      expression: "htmlValue"
    }
  }), _vm._v(" "), _c('v-flex', [_c('v-macro-field', {
    attrs: {
      "macro": "",
      "label": "html редактор2"
    },
    model: {
      value: (_vm.htmlValue2),
      callback: function($$v) {
        _vm.htmlValue2 = $$v
      },
      expression: "htmlValue2"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.htmlValue))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.replaceMacroTags(_vm.htmlValue)))]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v("Макро")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f3c20ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Test.vue
// module id = 1228
// module chunks = 1